export default "__VITE_ASSET__f0b264fc__"